import React, {useState, useEffect} from 'react';
import {useParams, useLocation} from 'react-router-dom';
import {APIClient} from '../../../utils/APIClient';
import {API_URL} from '../../../settings/local_settings';
import {LocalStorage} from '../../../utils/LocalStorage';
import {AccessService} from '../../../utils/AccessService';
import {PreviewProvider} from '../../../context/PreviewContext';
import {PreviewBanner} from './PreviewBanner';
import {Spinner} from '../../Spinner';
import {PortalHome} from '../../portal/PortalHome';
import {PortalDashboConnect} from '../../portal/PortalDashboConnect';

// Módulos que un CLIENT_USER puede ver en el portal simplificado
const CLIENT_PORTAL_MODULES = [
    AccessService.MODULE_MARKETING,
    AccessService.MODULE_REPORTS,
    AccessService.MODULE_DASHBO_MCP,
];

const getSectionFromPath = (pathname, clientId) => {
    const prefix = `/client/${clientId}/preview`;
    const rest = pathname.replace(prefix, '');
    if (rest === '/dashbo-connect' || rest === '/dashbo-mcp') return 'dashbo-connect';
    return 'home';
};

const SectionContent = ({section}) => {
    switch (section) {
        case 'dashbo-connect': return <PortalDashboConnect/>;
        default: return <PortalHome/>;
    }
};

export const ClientPortalPreview = () => {
    const {id} = useParams();
    const location = useLocation();

    const [clientName, setClientName] = useState('');
    const [agencyModules, setAgencyModules] = useState(null);
    const [branding, setBranding] = useState(null);
    const [loading, setLoading] = useState(true);

    const section = getSectionFromPath(location.pathname, id);

    // Obtener datos del cliente (nombre, logo de agencia)
    useEffect(() => {
        new APIClient(API_URL + 'client/' + id).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                setClientName(data.data.name || '');
            }
        });

        new APIClient(API_URL + 'client/' + id + '/portal/config/').call('GET').then((data) => {
            if (data && data.status === 'OK') {
                setBranding(data.data.branding);
            }
        });
    }, [id]);

    // Obtener módulos de la agencia para simular los del cliente
    useEffect(() => {
        const userId = LocalStorage.fetchUserId();
        if (!userId) {
            setAgencyModules([]);
            setLoading(false);
            return;
        }
        AccessService.GetUserModules(userId, (data) => {
            const userModules = data.modules || [];
            // Intersección con módulos disponibles para clientes
            const simulatedModules = CLIENT_PORTAL_MODULES.filter(m => userModules.includes(m));
            setAgencyModules(simulatedModules);
            setLoading(false);
        }, () => {
            setAgencyModules([]);
            setLoading(false);
        });
    }, []);

    if (loading) {
        return (
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
                <Spinner color="positive"/>
            </div>
        );
    }

    const previewValue = {
        isPreview: true,
        previewClientId: id,
        previewModules: agencyModules,
        previewBranding: branding,
    };

    return (
        <PreviewProvider value={previewValue}>
            <div className="preview-wrapper">
                <PreviewBanner clientId={id} clientName={clientName}/>
                <SectionContent section={section}/>
            </div>
        </PreviewProvider>
    );
};
